// Exact, code-owned capabilities. Role names are display metadata, never authority.
const crud = ['read', 'create', 'update', 'delete'] as const;
const documentActions = [...crud, 'confirm', 'cancel'] as const;
export const RESOURCE_ACTIONS = {
  users: ['read', 'create', 'update', 'assign_role', 'disable', 'reset_password', 'revoke_sessions'],
  roles: crud, audit: ['read'], dashboard: ['read'],
  suppliers: crud, customers: [...crud, 'lookup'], customer_prices: crud,
  categories: crud, materials: crud, 'materials.costs': ['read'],
  services: crud, 'services.prices': ['read'], service_lines: crud,
  cutting_sizes: crud, cutting_configs: crud, cutting_forms: crud,
  orders: documentActions, 'orders.financials': ['read'],
  production: ['read', 'print', 'qc', 'laminate', 'cut', 'rework', 'report_error', 'assign'],
  'production.costs': ['read'], delivery: ['read', 'assign', 'progress'],
  invoices: documentActions, receipts: documentActions, payments: documentActions,
  discounts: documentActions, debt_adjustments: documentActions, cash_book: ['read'],
  warehouse_receipts: documentActions, warehouse_receipt_requests: documentActions,
  warehouse_deliveries: documentActions, warehouse_checks: documentActions,
  notifications: ['read', 'update', 'delete'],
  'reports.sales': ['read'], 'reports.production': ['read'], 'reports.finance': ['read'],
  'reports.suppliers': ['read'], 'reports.inventory': ['read'], 'reports.laminate': ['read'],
  'reports.cutting': ['read'], 'reports.delivery': ['read'], reports: ['reconcile'],
} as const;

export type Resource = keyof typeof RESOURCE_ACTIONS;
export type Permission = {
  [R in Resource]: `${R}.${typeof RESOURCE_ACTIONS[R][number]}`
}[Resource];

export interface PermissionRequirement {
  allOf?: readonly Permission[];
  anyOf?: readonly Permission[];
}
